angular.module('app')
    .controller('LoginController',
    function ($localStorage, $uibModal, toastr) {
        var vm = this;

        var changePassword;
        var loggedIn;

        function init() {
            // Reset the local storage app state
            delete $localStorage.UtpAppState;
            // Get the ChangePassword and LoggedIn from the form in the MVC page
            changePassword = document.getElementById('ChangePassword').value == 'yes' || false;
            loggedIn = document.getElementById('LoggedIn').value == 'yes' || false;
            // Set the focus on the user name form input
            var userNameInput = document.getElementById('UserName');
            if (userNameInput != null) {
                userNameInput.focus();
            }   
            // We are not logged in so return
            if (!loggedIn) { return; }
            // We are logged in but need to change our password and on success relocate
            if (loggedIn && changePassword) { changePasswordModal(); }
        }
        init();

        function changePasswordModal() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                component: 'ChangePasswordComponent',
                size: 'sm'
            });

            // When we close the modal we want to know if the password was changed successfully
            modalInstance.result.then(
                // close callback - OK 
                function() {
                    toastr.info(
                        'Password has been changed successfully. Please login with your new password.'
                    );
                },
                // dismiss callback - cancel
                function() {
                    // We cancelled the modal, do nothing
                }
            );
        }

        // Obtained from
        //    http://stackoverflow.com/questions/2400935/browser-detection-in-javascript
        navigator.sayswho = (function () {
            var ua = navigator.userAgent,
                tem,
                M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if (/trident/i.test(M[1])) {
                tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE ' + (tem[1] || '');
            }
            if (M[1] === 'Chrome') {
                tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
            if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();

        // To check current broswers go to; http://browsehappy.com/
        if (!((navigator.sayswho).indexOf("IE 11") > -1 ||
            (navigator.sayswho).indexOf("IE 10") > -1 ||
            (navigator.sayswho).indexOf("IE") == -1)) {
            document
                .getElementById('lbltipAddedComment')
                .innerHTML = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Browser version '" +
                navigator.sayswho +
                "' is not supported on this system";
            document.getElementById('btnLogin').disabled = true;
        }
    });